import { useEffect } from 'react';
import store from 'store';

export default function useFetchOnce(fetchResourceActionCreator, resourceSelectors = {}, update = false) {

  useEffect(() => {
    const state = store.getState();
    const loading = resourceSelectors.isLoading ? resourceSelectors.isLoading(state) : false;
    if (!loading) {
      if (update
        || (resourceSelectors.getLoadPending ? resourceSelectors.getLoadPending(state) : true)
        || (resourceSelectors.getError ? resourceSelectors.getError(state) : undefined)
      ) {
        store.dispatch(fetchResourceActionCreator());
      }
    }
  }, []);
}
